import { render, staticRenderFns } from "./CodeDialog.vue?vue&type=template&id=95c58d90&scoped=true"
import script from "./CodeDialog.vue?vue&type=script&lang=js"
export * from "./CodeDialog.vue?vue&type=script&lang=js"
import style0 from "./CodeDialog.vue?vue&type=style&index=0&id=95c58d90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c58d90",
  null
  
)

export default component.exports